export default __webpack_public_path__ + "static/Creative_community_noissueChallenge_badge-3c60146d9a7f5bd6f92ab08852b1c1ab.svg";